import React, { FC } from "react";
import type { AutomationGlobalConsentManagementProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const AutomationGlobalConsentManagement: FC<
  AutomationGlobalConsentManagementProps
> = ({ content, cover }) => {
  return (
    <section className="automationGlobalConsentManagement">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={732} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover?.file?.url && (
          <Image
            className="automationGlobalConsentManagement--cover"
            src={cover as any}
            alt={cover.title}
          />
        )}
      </div>
    </section>
  );
};
